import React from "react";
import { Button, dialog } from "../../../nq-component";
import {
  addSchemaUseCase,
  updateSchemaUseCase,
  deleteSchemaUseCase,
} from "../../../usecases/schema/usecases";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { exportCSVUseCase } from "../../../usecases/csv/usecases";
import { Progress, InfiniteScroll } from "../../../nq-component";
import withRouter from "../../../withRouter";
import BaseListPage from "../../../base/BaseListPage";
import NavBar from "../../../components/navbar";
import InputFactory from "../../../components/InputFactory";
import EmployeeListPresenter from "./EmployeeListPresenter";
import Table from "../../../components/Table";
import EmployeeDetails from "./components/EmployeeDetails";
import excludeFields from "./components/./ExcludeField";
import DialogRequest from "./components/DialogRequest";
import DialogContinue from "./components/DialogContinue";
import DialogSuccess from "./components/DialogSuccess";
import excludedFields from "./excludedFields";

class EmployeeListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new EmployeeListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      exportCSVUseCase(),
      addSchemaUseCase(),
      updateSchemaUseCase(),
      deleteSchemaUseCase()
    );
    this.state = {
      objects: [],
      selected: [],
      loading: false,
      total: 0,
      count: 0,
      where: {},
      showDetails: false,
      empDetails: {},
      showFilters: false,
      formData: {
        requestType: "",
        remarks: "",
        attachment: "",
      },
    };
  }

  getCollectionName() {
    return "employees";
  }

  onClickAdd() {
    this.presenter.onClickAdd();
  }

  clickData(object, index) {
    this.setState({
      showFilters: true,
      showDetails: true,
      empDetails: object,
    });
  }

  hideFilter() {
    this.setState({ showFilters: false });
  }

  onClickEdit() {
    const { empDetails } = this.state;
    this.presenter.onClickEdit(empDetails);
  }

  onClickUpdateStatus() {
    const { empDetails } = this.state;
    this.presenter.onClickUpdateStatus(empDetails);
  }

  onClickView() {
    const { empDetails } = this.state;
    const view = "viewing";
    this.navigateTo(`/admin/employees/form/${view}/${empDetails?.id}`);
  }

  onChangeObject(value, field) {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [field]: value,
      },
    }));
  }

  submitRequest(empDetails, coordinator) {
    this.presenter.handleSubmit(this.state.formData, empDetails, coordinator);
  }

  handleSubmit = () => {
    dialog.close();
    const { empDetails } = this.state;
    const coordinator = this.getCurrentUser();

    dialog.fire({
      html: (
        <>
          <DialogContinue
            handleSubmit={() => this.submitRequest(empDetails, coordinator)}
          />
        </>
      ),
      footer: false,
    });
  };

  onClickRequest() {
    const schema = this.getSchema();
    dialog.fire({
      html: (
        <>
          <DialogRequest
            schema={schema}
            onChangeData={this.onChangeObject.bind(this)}
            handleSubmit={this.handleSubmit.bind(this)}
          />
        </>
      ),
      footer: false,
    });
  }

  showFilter() {
    this.setState({ showFilters: true });
  }

  successModal() {
    dialog.fire({
      html: (
        <>
          <DialogSuccess />
        </>
      ),
      footer: false,
    });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const {
      objects,
      selected,
      count,
      progress,
      empDetails,
      showFilters,
      showDetails,
    } = this.state;
    if (!schema) return <Progress />;
    const user = this.getCurrentUser();
    console.log(objects);
    return (
      <>
        <NavBar user={user} />
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div className="d-flex justify-content-between align-items-center">
                <h1 className="fw-bold text-capitalize">
                  {schema.label || this.getCollectionName()}
                </h1>
                <div className="text-nowrap">
                  <span className="ms-2">
                    {selected.length > 0 ? "Selected: " : "Total: "}
                  </span>
                  <span className="fs-sm text-nowrap">
                    {selected.length > 0 ? selected.length : objects.length}
                  </span>
                  <span className="ms-1">of </span>
                  <span className="fs-sm text-nowrap">{count}</span>
                </div>
              </div>
              <div className="d-flex justify-content-start">
                <p
                  className="align-self-end m-0 cursor-pointer fw-bold"
                  style={{ color: `#D18237` }}
                  onClick={this.showFilter.bind(this)}
                >
                  <i class="bi bi-filter"></i>Filters
                </p>
              </div>
              <div className="d-flex">
                {showFilters ? (
                  <div
                    className="d-flex flex-column me-2 w-50"
                    style={{
                      width: "50%",
                      position: "sticky",
                      top: 0,
                      alignSelf: "flex-start",
                      zIndex: 1,
                    }}
                  >
                    <div className="card p-3 mt-1">
                      <h6 className="fw-bold" style={{ color: "black" }}>
                        <i
                          className="bi bi-arrow-left cursor-pointer me-2"
                          onClick={this.hideFilter.bind(this)}
                        ></i>
                        Filters
                      </h6>

                      <div className="d-flex mt-3 d-flex flex-column gap-2">
                        {Object.keys(schema.filters || {}).map((field) => {
                          let { type, ...options } = schema.filters[field];
                          return (
                            <InputFactory
                              key={field}
                              className="ms-1"
                              type={type}
                              field={field}
                              where={{}}
                              onChange={this.onChangeFilter.bind(this, type)}
                              {...options}
                            />
                          );
                        })}
                        {/* <Search
                          schemas={this.getSchemas()}
                          className="mt-1"
                          onSubmit={this.searchSubmit.bind(this)}
                          fields={schema.fields}
                        /> */}
                      </div>
                    </div>
                    {showDetails && empDetails && (
                      <div>
                        <EmployeeDetails
                          userLogin={user}
                          empDetails={empDetails}
                          clickView={this.onClickView.bind(this)}
                          clickEdit={this.onClickEdit.bind(this)}
                          clickStatus={this.onClickUpdateStatus.bind(this)}
                          clickRequest={this.onClickRequest.bind(this)}
                        />
                      </div>
                    )}
                  </div>
                ) : (
                  ""
                )}

                <div className=" w-100">
                  <Table
                    fields={schema.fields}
                    onClick={this.clickData.bind(this)}
                    objects={objects}
                    // selectable
                    // collapsable
                    excludeFields={Object.keys(schema.fields).reduce(
                      (acc, key) => {
                        const options = schema.fields[key];

                        excludedFields.map((field) => {
                          acc.push(field);
                        });
                        if (options.read === false) {
                          acc.push(key);
                        }
                        switch (options._type || options.type) {
                          case "Relation":
                          case "Array":
                          case "Object":
                          case "File":
                            acc.push(key);
                            break;
                          default:
                        }
                        return acc;
                      },
                      excludeFields
                    )}
                    selected={selected}
                    onSelect={this.onSelect.bind(this)}
                    onSelectAll={this.onSelectAll.bind(this)}
                    progress={progress}
                    onClickItem={this.onClickItem.bind(this)}
                    onSort={this.onClickSort.bind(this)}
                    className="mt-1"
                  />
                </div>
              </div>
            </div>
          </InfiniteScroll>
        </div>
        {user.roles[0].id === "Admin" && (
          <div className="position-fixed bottom-0 end-0 m-4">
            <Button
              className="btn shadow-sm text-white"
              onClick={this.onClickAdd.bind(this)}
              style={{
                width: "50px",
                height: "50px",
                borderRadius: "25px",
                backgroundColor: "#e09552",
              }}
            >
              <i className="bi bi-plus-lg" />
            </Button>
          </div>
        )}
      </>
    );
  }
}

export default withRouter(EmployeeListPage);
